import React from "react";
import { Link } from "react-router-dom";

export default function PostCard({ post }) {
  return (
    <div className="card h-100 shadow-sm border-0">
      <div className="card-body">
        <h5 className="card-title">{post.titulo}</h5>

        <p className="card-text text-muted">{post.resumo}</p>

        <Link to={`/blog/${post.slug}`} className="btn btn-outline-success">
          Ler artigo
        </Link>
      </div>
    </div>
  );
}